const EquipmentTab = ({ equipment, setSelectedEquipment, setShowTicketModal, darkMode }) => {
  const getEquipmentIcon = (type) => {
    const icons = {
      'laptop': '💻',
      'phone': '📱',
      'monitor': '🖥️',
      'keyboard': '⌨️',
      'mouse': '🖱️'
    };
    return icons[type] || '🖥️';
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Equipamentos Atribuídos</h3>
      </div>
      
      {equipment.length === 0 ? (
        <p className={`text-center py-8 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem equipamentos atribuídos</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {equipment.map((item, idx) => (
            <div key={idx} className={`p-4 rounded-lg ${darkMode ? 'bg-slate-700/50' : 'bg-slate-100'}`}>
              <div className="text-3xl mb-2">
                {getEquipmentIcon(item.equipment_type)}
              </div>
              <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{item.brand} {item.model}</p>
              <p className={`text-sm font-mono ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{item.serial_number}</p>
              {item.asset_tag && (
                <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Tag: {item.asset_tag}</p>
              )}
              <button
                onClick={() => { setSelectedEquipment(item); setShowTicketModal(true); }}
                className="mt-3 w-full px-3 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-500 transition-colors"
                data-testid={`create-ticket-${item.equipment_id}`}
              >
                🎫 Abrir Ticket Suporte
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EquipmentTab;
